import React from 'react'

const Aboutme = () => {
  return (
    <div className="space-y-8 animate-fadeIn">
      <div className="bg-white/5 backdrop-blur-md rounded-2xl border border-white/10 p-8 hover:bg-white/10 transition-all duration-300">
        <h1 className="text-4xl md:text-5xl font-bold font-serif text-white mb-4 bg-clip-text text-transparent bg-gradient-to-r from-purple-400 to-pink-600">
          Sarvadnya Awaghad
        </h1>
        <h2 className="text-xl md:text-2xl text-purple-300 font-medium">
          Web Developer & Tech Enthusiast
        </h2>
        <div className="mt-4 flex flex-wrap gap-3">
          <span className="px-3 py-1 bg-purple-500/20 rounded-full text-purple-200 text-sm border border-purple-500/30">Student</span>
          <span className="px-3 py-1 bg-pink-500/20 rounded-full text-pink-200 text-sm border border-pink-500/30">VESIT '25</span>
          <span className="px-3 py-1 bg-indigo-500/20 rounded-full text-indigo-200 text-sm border border-indigo-500/30">Developer</span>
        </div>
      </div>

      <div className="bg-white/5 backdrop-blur-md rounded-2xl border border-white/10 p-8 hover:bg-white/10 transition-all duration-300">
        <p className="text-gray-300 text-lg leading-relaxed font-sans">
          Hi everyone! I am a Tech Enthusiast who loves to explore the world through my trusty 1920x1080 px screen.
          I not only enjoy diving into the intricacies of technology but also find great joy in connecting with people.
          I believe in cherishing every moment and embracing the beauty of life. I am excited to apply my knowledge
          and abilities to contribute towards the overall success and growth of any organization.
        </p>
      </div>
    </div>
  )
}

export default Aboutme